define('common/models/global',['require','exports','module','backbone','env'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    // urlRoot: [config.apiHost, "globals"].join("/"),
    parse: function(json, options) {
      if (json.content) json.content += "";
      if (!json.id) json.id = 'c' + Math.floor(Math.random()*1000);
      return Backbone.Model.prototype.parse.call(this, json, options);
    },
    defaults: {
      name: "Default Name",
      content: ""
    },
    validate: function(attrs) {
      var name = attrs.name,
          global = this.collection.findWhere({name: name});
      return global && this != global && name;
    }
  });

});

